import React from "react"

import SkillCard from './SkillCard';
import SkillCard2 from './SkillCard2';
import SkillCat from './SkillCats';
import SectionDivider from './SectionDivider';
import Icon from './Icon';

import styles from './skill.module.css';

import SkillRadar from './SkillRadar';

import {
  VictoryPie,
  VictoryBar,
  VictoryChart,
  VictoryAxis,
  VictoryLabel
} from 'victory';

const sampleData = [
  { x: 1, y: 2 },
  { x: 2, y: 3 },
  { x: 3, y: 5 },
  { x: 4, y: 4 },
  { x: 5, y: 6 }
]

const data2 = [[
    {x: "Learning Speed", y: .7},
    {x: "Algorithms", y: .8},
    {x: "Security", y: .9},
    {x: "Documentation", y: .9},
    {x: "Autonomy", y: .9},
  ]
]

const maxima2 = {
  "Learning Speed": 10,
  "Algorithms": 10,
  "Security": 10,
  "Documentation": 10,
  "Autonomy": 10,
};

const data1 = [[
    {x: "Innovation", y: .7},
    {x: "Convention", y: .5},
    {x: "Maintainability", y: .8},
    {x: "Complexity", y: .5},
    {x: "Security", y: .7},
    {x: "Speed", y: .6}
  ]
]

const maxima1 = {
  "Innovation": 10,
  "Convention": 10,
  "Maintainability": 10,
  "Complexity": 10,
  "Security": 10,
  "Speed": 10,
};

const frameworksIKnow = [
  ['React', 3],
  ['Vue', 3], 
  ['Redux', 3],
  ['Rails', 3],
  ['Apollo', 3],
  ['jQuery', 3],
  ['Express', 3],
  ['Serverless', 3],
]

const languages = [
  ['Ruby', 3],
  ['Javascript', 3],
  ['Python', 3],
  ['C++', 3],
  ['CSS', 3],
  ['HTML', 3],
  ['TypeScript', 3],
  ['Golang', 3],
]

const tools = [
  ['Docker', 3],
  ['Illustrator', 3],
  ['AWS', 3],
  ['Postgress', 3],
  ['MongoDB', 3],
  ['Webpack', 3],
  ['GraphQL', 3],
  ['Node', 3],
]

const Activity = ({ coreSkills, moreSkills, frameworks }) => {
  return (
    <div className="fullSection">
    <div className="whitespace"/>
    <div className="whitespace"/>
    <div className={styles.blurb}>

      <div className={styles.header}>
        Hard Skills:
      </div>
      <div className={styles.whiteSpace}/>
      <div className={styles.splash}>
        My technical skills are rooted in a strong creative drive and an appreciation for technical design.
      </div>
    </div>

        <div className="whitespace"/>

        <div className={styles.skillCardContainer}>
          <SkillCard2
            title={"Front-End Development"}
            text={'Front-End development is currently my peak area of confidence. It is often complex yet needs to work in the wilds of the internet, so I bring all my creativity and determination to the table.'}
            icon={'frontend'}
          />
          <SkillCard2
            title={'Back-End Development'}
            text={'Most of my Back-End experience has been developing Sinatra, Rails, Express.js, and Serverless Framework APIs. I\'m very passionate about expanding my experience in this area of development.'}
            icon={'api'}
          />
          <SkillCard2
            title={"Solutions Architecture"}
            text={'I am currently studying to aquire my Solutions Architect Associates certification from AWS. I was previously responsible for deploying services to the cloud and have since found an avid interest in cloud solutions.'}
            icon={'systems'}
            icon={'systems'}
            />

        </div>


        <div className="whitespace"/>


        <SkillCat skills={languages} title={'Languages:'}/>

        <div className="whitespace"/>

        <SkillCat skills={frameworksIKnow} title={'Frameworks:'}/>

        <div className="whitespace"/>

        <SkillCat skills={tools} title={'Tools:'}/>

        <div className="whitespace"/>

        <div className={styles.chartRow}>
          <div className={styles.chartWrapper}>
              <div className={styles.chartWrapperText}> Technical Design: </div>
                <SkillRadar color={"orange"}  maxima={maxima1} data={data1} />
            </div>
        </div>

        <div className="whitespace"/>

      <div className="whitespace"/>
      <div className="whitespace"/>


      <div className={styles.header}>
        Soft Skills:
      </div>

      <div className={styles.splash}>
        I actively develop my ability to communicate and collaborate. I believe that the foundation of good software begins with good teamwork.
      </div>

      <div className="whitespace"/>

      <div className={styles.skillCardContainer}>

        <SkillCard2
          title={"Agile Process"}
          text={'Complexity and Agile go hand in hand. Therefore, Agile is vital to building inspiring software and maintaining killer team dynamics.'}
          icon={'agile'}
        />
        <SkillCard2
          title={"Learning Speed"}
          text={'I view learing as a way of life and many of my skills are self-taught. I pride myself on the ability to adapt quickly to new environments and rapidly aquire new skills.'}
          icon={'learning'}
        />
        <SkillCard2
        title={"Teamwork"}
        text={'Teamwork and collaboration are incredibly rewarding both personally and professionally. I believe in open communication, supporting your teamates\' strengths, and depending on others responsibly.'}
        icon={'teamwork'}
        />
        <SkillCard2
          title={"Problem Solving"}
          text={'Problem solving is a common process, but the strategies are varied and endlessly diverse. I think problem solving is achieved by both analysis and intuition and plays a huge part in the creative process.'}
          icon={'problem Solving'}
          />

      </div>


      <div className={styles.whiteSpace}/>
      <div className={styles.whiteSpace}/>

      <div className={styles.chartRow}>

        <div className={styles.chartWrapper}>

          <div className={styles.chartWrapperChart}>
            <div className={styles.chartWrapperText}> Environment Balance </div>

              <VictoryPie
                 // style={{ labels: { fill: "white" } }}
                 innerRadius={5}
                 cornerRadius={50}
                 padAngle={3}
                 // labelRadius={120}
                 tickLabelCompoenent={
                   <VictoryLabel labelPlacement="vertical"/>
                 }
                 data={[
                   { x: "Trust", y: 4 },
                   { x: "Discipline", y: 3 },

                   { x: "Team Growth", y: 7 },
                   { x: "Individual Growth", y: 5 },

                   { x: "Process", y: 5 },
                   { x: "Common Sense", y: 6 },

                 ]}
              />
          </div>
        </div>
      </div>

      <div className={styles.whiteSpace}/>
      <div className={styles.whiteSpace}/>
    </div>
  )
}

export default Activity
